import { Text } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';
import { IconType } from 'react-icons';

import {
  DeliverableActionKeyGQLType,
  EventForRenderFragmentGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { deliverableStatusLabelDEPRECATED } from '../../constants';
import {
  getDeliverablesPayloadWithAssert,
  getInsertedDeliverableStatusPayloadV1WithAssert,
  getSubmittedDeliverableSubmissionPayloadV1WithAssert,
  getUpdatedDeliverableStatusPayloadV1WithAssert,
} from 'packages/common-frontend/utils';
import { FiClock, FiEdit2, FiSend } from 'react-icons/fi';

const deliverables: {
  [key in DeliverableActionKeyGQLType]: {
    Component: ({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) => React.ReactElement;
    icon: IconType;
    PanelComponent?: ({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) => React.ReactElement;
  };
} = {
  insertDeliverableItem: {
    Component: function InsertDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName, targetName } = event;
      const payload = getDeliverablesPayloadWithAssert(event);
      const {
        deliverableItem: { creditFacilityName },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` surfaced a deliverable: `}
          <strong>{targetName}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiClock,
  },
  updateDeliverableItemStatus: {
    Component: function InsertDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName, targetName } = event;
      const payload = getDeliverablesPayloadWithAssert(event);
      const {
        deliverableItem: { creditFacilityName, status },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` updated `}
          <strong>{targetName}</strong>
          {` to `}
          <strong>{`${_.toLower(
            deliverableStatusLabelDEPRECATED[status].label,
          )}`}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiEdit2,
  },
  // deliverables v3 events
  insertedDeliverable: {
    Component: function InsertedDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName, targetName } = event;
      const payload = getInsertedDeliverableStatusPayloadV1WithAssert(event);
      const {
        deliverable: { creditFacilityName },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` surfaced a deliverable: `}
          <strong>{targetName}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiClock,
  },
  updatedDeliverableStatus: {
    Component: function UpdatedDeliverableStatusComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName, targetName } = event;
      const payload = getUpdatedDeliverableStatusPayloadV1WithAssert(event);
      const {
        deliverable: { creditFacilityName, status },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` updated `}
          <strong>{targetName}</strong>
          {` to `}
          <strong>{`${_.toLower(status)}`}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiEdit2,
  },
  submittedDeliverableSubmission: {
    Component: function SubmittedDeliverableSubmission({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName, targetName } = event;
      const payload = getSubmittedDeliverableSubmissionPayloadV1WithAssert(
        event,
      );
      const {
        deliverable: { creditFacilityName },
      } = payload;
      return (
        <Text>
          <strong>{actorName}</strong>
          {` submitted `}
          <strong>{targetName}</strong>
          {` for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiSend,
  },
};

export default deliverables;
